/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 사용자 페이지 레이아웃
 * 버전 : 1.0
 * 파일명 : UserLayout.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * 수정 : 2025-07-02, 강동형 : 저작권 추가, 더보기 버튼 추가에 따른 Dialog reset 시점 고도화
 * ================================================================ 
 * 수정 : 2025-07-09, 강동형 : 뒤로가기로 종료되는 이벤트 제어 시도
 * ================================================================ */

import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NavBar from "src/components/common/NavBar";
import { useDialogStore, useMainPageDialogStore, useSchoolListDialogStore } from "src/stores/DialogStore";
import { useBackHandlerStore, useNavbarStore } from "src/stores/UIStore";
import AppModal from "src/components/modals/AppModal";
import { useModalStore } from "src/stores/ModalStore";
import { useRecruitStore } from "src/stores/RecruitStore";
import { useInterestedFilterStore } from "src/stores/InterestedStore";

const UserLayout = () => {
  const location = useLocation();
  const isNavVisible = useNavbarStore((state)=>state.isvisible)
  const showNavBar = !['/', '/signup', '/signup-details', '/signup-deny', '/find-username', '/find-password'].includes(location.pathname);
   
  const isOpen = useSchoolListDialogStore((state) => state.isOpen);    
  const closeDialog2 = useDialogStore((state) => state.setField);
  const isOpen2 = useDialogStore((state) => state.isOpen);
  const closeDialog3 = useMainPageDialogStore((state) => state.setField);
  const isOpen3 = useMainPageDialogStore((state) => state.isOpen);
  const isOpen4 = useRecruitStore((state) => state.isOpen);
  const open = useModalStore((state)=>state.open)
  const setisPopUp = useBackHandlerStore((state)=>state.setisPopUp)
  const isOpen5= useInterestedFilterStore((state)=>state.isOpen)
  const isSideBar = useNavbarStore((state)=>state.isSideBarOpen)
  const customAction = useBackHandlerStore((state)=>state.customAction)

  const [isMobile, setIsMobile] = useState(false);

  const [modalCount,setModalCount] = useState(1)
  const [prevCount,setPrevCount] = useState(0)

  const modalCountRef = useRef(modalCount);

  // modalCount가 바뀔 때마다 ref에도 동기화
  useEffect(() => {
    modalCountRef.current = modalCount;
  }, [modalCount]);

  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };
    const checkDevice = () => {
      const userAgent = navigator.userAgent
      setIsMobile(/android/i.test(userAgent) || /iPad|iPhone|iPod/.test(userAgent));
    };

    checkDevice();
    setVh(); // 최초 실행
    window.addEventListener('resize', setVh); // 리사이즈마다 다시 계산

    return () => window.removeEventListener('resize', setVh);
  }, []);

  useEffect(() => {
    // closeDialog('isOpen', false);
    closeDialog2('isOpen', false);
    closeDialog3('isOpen', false);
    // closeDialog4('isOpen', false);
  }, [location.pathname]);

  // 1) 모달이 닫힘 → 열림 전환될 때만 히스토리 스택에 push
  useEffect(() => {
    const isModalOpen = isOpen || isOpen2 || isOpen3 || isOpen4 || isOpen5 || open || isSideBar;
    const shouldPush = isModalOpen || typeof customAction === "function";
    // “닫힘 → 열림” 전환 시 || prevCount와 비교해서 더 적어지면 추가안함 *현재 최대 2개라서 작동함*
    if (shouldPush && modalCount >= prevCount) {
      window.history.pushState({ modal: modalCount }, "", window.location.pathname);
      // console.log("[pushState] 모달 열림 또는 customAction 함수, 히스토리 한 칸 추가");
      setModalCount((prev)=>prev+1)
      setPrevCount((prev)=>prev+1)
    }
    else{
      setModalCount(0)
      setPrevCount(0)
    }
    // 현재 상태를 다음 이펙트에서 비교할 수 있도록 저장
    setisPopUp(isModalOpen)
  }, [isOpen, isOpen2, isOpen3, isOpen4, isOpen5, open, customAction, isSideBar]);

  // 2) popstate 이벤트는 컴포넌트 마운트 시 단 한 번만 등록
  useEffect(() => {
    const handlePopState = (event: PopStateEvent) => {
      const {isOpen: schoolListDialog,setField: setSchoolListDialog} = useSchoolListDialogStore.getState()
      const {isOpen: mainDialog,setField: setMainDialog} = useDialogStore.getState()
      const {isOpen: mainPageDialog,setField: setMainPageDialog} = useMainPageDialogStore.getState()
      const {isOpen: recruitDialog,setField: setRecruitDialog} = useRecruitStore.getState()
      const {open: modal,setField: setModal} = useModalStore.getState()
      const {isOpen: interestedDialog,setField: setInterestedDialog} = useInterestedFilterStore.getState()
      const {isSideBarOpen: sideBar,setField: setSideBar} = useNavbarStore.getState()
      const isModalOpen = schoolListDialog || mainDialog || mainPageDialog || recruitDialog || modal || interestedDialog || sideBar;
      
      // (1) 모달이 열려 있으면: 닫고, 히스토리 보정(pushState)
      if (isModalOpen) {
        setModalCount(modalCountRef.current-1)
          if (sideBar) {
          // console.log("사이드바 닫기");
          setSideBar('isSideBarOpen', false);
        }
          else if (mainDialog) {
          // console.log("메인다이얼 로그 닫기");
          setMainDialog('isOpen', false);
        } else if (schoolListDialog) {
          // console.log("스쿨리스트 다이얼로그 닫기");
          setSchoolListDialog("isOpen", false);
        } else if (mainPageDialog) {
          // console.log("메인페이지 다이얼로그 닫기");
          setMainPageDialog("isOpen", false);
        } else if (modal) {
          // console.log("모달 닫기");
          setModal("open", false);
        } else if (recruitDialog) {
          // console.log("리크루트 다이얼로그 닫기");
          setRecruitDialog("isOpen", false);
        } else if (interestedDialog) {
          // console.log("인터레스트 다이얼로그 닫기");
          setInterestedDialog("isOpen", false);
        }

        return;
      }

      // (2) 모달도 없고 customAction 도 없으면: 진짜 뒤로가기 허용
      const { customAction } = useBackHandlerStore.getState();
      if (typeof customAction !== "function") {
        // console.log("[popstate] 더 막을 게 없으니 진짜 뒤로가기");
      } else {
        // console.log("[popstate] customAction이 있어 추가 처리 생략");
        customAction()
      }
    };

    // 이벤트 등록
    window.addEventListener("popstate", handlePopState);
    // console.log("popstate 이벤트 핸들러 등록");

    // 정리(cleanup)
    return () => {
      window.removeEventListener("popstate", handlePopState);
      // console.log("popstate 이벤트 핸들러 해제");
    };
  }, []); // 빈 배열: 마운트/언마운트 시에만 실행

  if (!isMobile) {
    return (
      <div className="access-denied">
        <h1>Access Denied</h1>
        <p>This website is only accessible on mobile devices.</p>
      </div>
    );
    }

    return (
      <>
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
          {showNavBar && <NavBar />}
          <ToastContainer />
          <AppModal />
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              paddingTop: !isNavVisible ? '0px' : (showNavBar ? '48px' : '0px'),
            }}
          >
            <Outlet />
          </div>
        </div>
      </>
    );
  };
  
export default UserLayout;